exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.datetime-container{\r\n\tdirection: ltr;\r\n\tbackground-color: #e8ebee;\r\n\tpadding: 10px;\n}\r\n", ""]);

// exports
